/**
 * @fileoverview Handle newsletter submissions.
 */

var $ = require('jquery');

var errorShown = false;

function showError(el, txt) {
  !errorShown && el.prepend('<div class="alert alert-danger">' + txt + '</div>');
  errorShown = true;
}

function handleNewsletterSubmit(ev) {
  ev.preventDefault();

  var $this = $(this);
  var inputs = $this.find('.required');
  var valid = true;
  errorShown = false;

  inputs.each(function(i, el) {
    if (!el.value) {
      valid = false;
      var formGroup = $(el).parent();
      formGroup.addClass('has-error');
    }
  });

  if (!valid) {
    showError($this, 'Please ensure all fields are filled in.');
    return;
  }

  $.ajax({
    url: this.action,
    data: $this.serialize(),
    crossDomain: true,
    dataType: 'jsonp',
    jsonp: 'c'
  })
  .done(function() {
    $this.html('<div class="alert alert-success">Thanks for signing up!</div>')
  })
  .fail(function() {
    //showError('Oops! Something went wrong. Can you try again?');
  });
}

module.exports = {
  handleNewsletterSubmit: handleNewsletterSubmit
};
